import WebRepository from '../web/WebRepository'
import Api from 'clients/web/Api'
import AppointmentsWithPatientsMonth from 'model/AppointmentsWithPatientsMonth'

function mapDocument(document: any): any {
  const { _id, _rev, ...values } = document
  return {
    id: _id,
    rev: _rev,
    ...values,
  }
}

function AppointmentWithPatientMap(document: any): any {
  const { appointment, patient, doctorName } = document
  if (patient && appointment) {
    return {
      appointment: mapDocument(appointment),
      patient: mapDocument(patient),
      doctorName: doctorName,
    }
  } else {
    console.log('Error appointment with no patient', appointment)
    return null
  }
}

export class AppointmentsWithPatientsRepository extends WebRepository<
  AppointmentsWithPatientsMonth
> {
  constructor() {
    super(new Api('appointments'))
  }

  async getAppointmentsWithPatients(selector: any): Promise<AppointmentsWithPatientsMonth> {
    return super.aggregate(
      {
        withPatient: true,
        selector,
      },
      AppointmentWithPatientMap,
    )
  }
}

export default new AppointmentsWithPatientsRepository()
